import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { theme } from '@styles/theme';
const paddingStyles = {
    none: css `padding: 0;`,
    sm: css `padding: ${theme.spacing.sm};`,
    md: css `padding: ${theme.spacing.md};`,
    lg: css `padding: ${theme.spacing.lg};`,
};
const StyledCard = styled.div `
  background-color: ${theme.colors.background.secondary};
  border: 1px solid ${theme.colors.border.primary};
  border-radius: ${theme.borderRadius.lg};
  transition: all ${theme.transitions.fast};

  ${({ $padding }) => paddingStyles[$padding]}

  ${({ $hoverable }) => $hoverable &&
    css `
      &:hover {
        border-color: ${theme.colors.border.secondary};
        transform: translateY(-2px);
        box-shadow: ${theme.shadows.md};
      }
    `}

  ${({ $clickable }) => $clickable &&
    css `
      cursor: pointer;
    `}
`;
export function Card({ children, padding = 'md', hoverable = false, onClick, className, }) {
    return (_jsx(StyledCard, { "$padding": padding, "$hoverable": hoverable, "$clickable": !!onClick, onClick: onClick, className: className, children: children }));
}
// Sub-components for more complex card structures
export const CardHeader = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${theme.spacing.md};
  border-bottom: 1px solid ${theme.colors.border.primary};
`;
export const CardTitle = styled.h3 `
  font-size: ${theme.typography.fontSize.lg};
  font-weight: ${theme.typography.fontWeight.semibold};
  color: ${theme.colors.text.primary};
  margin: 0;
`;
export const CardContent = styled.div `
  padding: ${theme.spacing.md};
`;
export const CardFooter = styled.div `
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: ${theme.spacing.sm};
  padding: ${theme.spacing.md};
  border-top: 1px solid ${theme.colors.border.primary};
`;
